import React from 'react'

import Grid, { Col } from '../../../../components/pdf/Grid'
import Image from '../../../../components/pdf/Image'
import View from '../../../../components/pdf/View'

const CoverPage = () => {
  return (
    <View pageBreakAfter>
      <Grid direction="column" align="start" style={{ gap: 100 }}>
        <Col>
          <Image src="/pdfs/sannygold/logo.jpg" maxWidth={100} />
        </Col>
        <Col>
          <Image src="/pdfs/sannygold/cover-image.jpg" />
        </Col>
        <Col width="100%">
          <Grid justify="center">
            <Image src="/pdfs/sannygold/cover-description.jpg" maxWidth={400} />
          </Grid>
        </Col>
      </Grid>
    </View>
  )
}

export default CoverPage
